import React from "react"
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import Heading from "@amzn/meridian/heading";
import {MobileDisplay} from "../common/MobileDisplay";

/**
 * Returns the page heading and description
 * @param head
 * @param headAlt
 * @param desc
 * @param descAlt
 * @param tab
 * @param tabAlt
 * @return JSX.Element
 */
const PageHeader = ({head, headAlt, desc, descAlt, tab, tabAlt}) => {
    return (
        <Column spacing={"none"}>
            <MobileDisplay visibility={true}>
                <Text type={"h100"} spacingTop={"medium"} color={"secondary"}><FormattedMessage id={tab} defaultMessage={tabAlt} /></Text>
            </MobileDisplay>
            <Heading level={2} type="h400" alignment="left">
                <FormattedMessage id={head} defaultMessage={headAlt} />
            </Heading>
            <MobileDisplay visibility={false}>
                <Text color={"secondary"}><FormattedMessage id={desc} defaultMessage={descAlt} /></Text>
            </MobileDisplay>
        </Column>
    )
}

PageHeader.propTypes = {
    head: PropTypes.string,
    headAlt: PropTypes.string,
    desc: PropTypes.string,
    descAlt: PropTypes.string,
}

export default PageHeader;


// WEBPACK FOOTER //
// ./src/components/util/PageHeader.js